import React from "react";
import { graphql } from "gatsby";
import { Button } from "@agria/theme/src/components/button";
import { ReferAFriend } from "./dynamicButtons/ReferAFriend";
import { VetGuideDownload } from "./dynamicButtons/VetGuideDownload";
import { VetClaim } from "./dynamicButtons/VetClaim";
import { VetAuthorisedClaim } from "./dynamicButtons/VetAuthorisedClaim";

interface DynamicButtonData {
  type: "Vet guide download" | "Refer a friend" | "Vet claim" | "Vet authorised claim";
}

interface ButtonBarLinkDataProps {
  data: DynamicButtonData;
  [key: string]: any;
}

export const DynamicButton: React.FC<ButtonBarLinkDataProps> = ({ data }) => {

  let type = data.type;

  //
  // Vet guide download
  //

  if (type === "Vet guide download") {
    return <VetGuideDownload />;
  }

  //
  // Refer a friend
  //

  if (type === "Refer a friend") {
    return <ReferAFriend />;
  }

  //
  // Vet Claim
  //

  if (type === "Vet claim") {
    return <VetClaim/>
  }

  //
  // Vet authorised claim
  //

  if (type === "Vet authorised claim") {
    return <VetAuthorisedClaim/>
  }
};

export const DynamicButtonQuery = graphql`
  fragment DynamicButton on UMBRACO_DynamicButtonComponentType {
    type
  }
`;
